import { TooltipV2 } from '@cimplico/components';
import { useEffect, useRef, useState } from 'react';

type WorkpaperQuickNavigateEntityNameProps = {
    entityName: string;
};

function WorkpaperQuickNavigateEntityName({ entityName }: WorkpaperQuickNavigateEntityNameProps): JSX.Element {
    const [isOverflowed, setIsOverflow] = useState(false);
    const textElementRef = useRef(null);

    useEffect(() => {
        if (textElementRef.current) {
            // @ts-ignore
            setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
        }
    }, [entityName]);

    return (
        <div className="w-[250px]">
            <TooltipV2 message={entityName} disabled={!isOverflowed}>
                <p
                    ref={textElementRef}
                    className="text-gray-800 dark:text-gray-100 pt-2 px-2 text-left text-xs font-medium cursor-default truncate"
                >
                    {entityName}
                </p>
            </TooltipV2>
        </div>
    );
}

export default WorkpaperQuickNavigateEntityName;
